"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayMode = void 0;
var GameplayMode;
(function (GameplayMode) {
    /**
     * Interactive mode correspond to the state the gameplay is in when the
     * user is solving the exercise. You can also think of this as "pre
     * validation mode"
     */
    GameplayMode["Interactive"] = "INTERACTIVE";
    /**
     * Non-interactive mode corresponds to the state the gameplay is in when
     * an answer has been validated and internal feedback is displayed. You can
     * also think of this as "post validation mode"
     */
    GameplayMode["NonInteractive"] = "NON_INTERACTIVE";
})(GameplayMode = exports.GameplayMode || (exports.GameplayMode = {}));
